
import { getBaseUrl } from "@api/helpers/url/baseUrl";
import { Configuration } from "@api/models/Configuration";
import { getBackend } from "@service/router/getters";
import { Vue, Component } from "vue-property-decorator";

@Component({})
export default class AuthFormProcessor extends Vue {
    tagsDataAttribute = 'data-auth-element';
    keyToDeleteFromGlobalScope: string[] = [];

    processForm(configuration: Configuration) {
        if (configuration.authForm && typeof configuration.authForm == 'string' && configuration.authForm.length > 0) {
            const html = document.createElement('html');
            html.innerHTML = configuration.authForm;
            const styles = html.querySelector('style');
            if (styles) {
                styles.setAttribute(this.tagsDataAttribute, '1');
                document.head.append(styles);
            }

            const previousKeys = Object.keys(window),
                    scripts = html.querySelector('script');
            if (scripts) {
                const newScript = document.createElement("script");
                const inlineScript = document.createTextNode(scripts.innerHTML);
                newScript.appendChild(inlineScript);
                newScript.setAttribute(this.tagsDataAttribute, '1');
                document.body.appendChild(newScript);
                Object.keys(window).forEach((item) => {
                    if (previousKeys.indexOf(item) < 0) {
                        this.keyToDeleteFromGlobalScope.push(item);
                    }
                })
            }

            const content = html.querySelector('body');
            if (content) {
                [].slice.call(content.children).forEach(item => {
                    (this.$refs['auth-container'] as HTMLElement)?.append(item);
                })
            }

            scripts && (window as any).ready?.();

            this.doSessionFromNative();
            this.addLoginEventToScope();
        }
        else {
            this.notFound();
        }
    }

    /**
     * executes session from native
     */
    doSessionFromNative() {
        const sessionObject = {
            baseUrl: process.env.VUE_APP_SERVER,
            backendUrl: getBaseUrl(),
            projectName: getBackend(this.$route.params.backend),
            appPlatform: "Web",
            appVersion: "1.0.0",
            language: this.$i18n.locale || 'en'
        };
        (window as any).sessionFromNative?.(JSON.stringify(sessionObject));
    }

    //add login method to receive session info from the form
    addLoginEventToScope() {
        (window as any).login = {
            postMessage: this.login
        }
    }

    async login(session: string): Promise<void> {
        throw new Error("Method not implemented.");
    }

    notFound() {
        this.$emit('notFound');
    }

    beforeDestroy() {
        //remove global handler
        document.removeEventListener('DOMContentLoaded', (window as any).ready);
        //remove global scope functions, if not configurable just set to undefined
        if (this.keyToDeleteFromGlobalScope && this.keyToDeleteFromGlobalScope.length) {
            this.keyToDeleteFromGlobalScope.forEach((item: string) => {
                if (Object.getOwnPropertyDescriptor(window, item)?.configurable) {
                    delete (window as any)[item];
                }
                else {
                    (window as any)[item] = undefined;
                }
            })
        }
        //remove scripts and styles
        const elements = document.querySelectorAll(`[${this.tagsDataAttribute}]`);
        if (elements) {
            for (let i = 0; i < elements.length; ++i) {
                elements[i].remove()
            }
        }
        //delete login handler from global scope
        delete (window as any).login;
    }
}

